const colors = {
  green: '#5C7855',
  greenLowlight: '#44583F',
  greenHighlight: '#5B8D4E',
  grey: '#707070',
  lightGrey: '#EEEEEE',
  white: '#FFFFFF',
  redPrimary: '#8F4D4D',
  redLowlight: '#743B3B',
  redHighlight: '#B54C4C',
  background: '#312E2E', //393232, 312E2E, 373535
  lightBackground: '#393232'
}

export default colors;